'use client'

import type React from 'react'

import { faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { FormattedMessage, Link } from '@b-stock/fe-core/bstock-react'
import { Colors } from '@b-stock/fe-core/design-system'

import { getStorefrontUrlFromSlug } from '@/app/buy/seller/[sellerSlug]/getStorefrontUrl'

import type { SellerTile as SellerTileData } from './content'
import { LINKS, SELLERS } from './content'
import {
  Inner,
  NotOnPhone,
  Section,
  SectionBody,
  SectionTitle,
  SellerLogo,
  sellerLogoBox,
  SellerTile,
  SellerTileText,
  TileChevron,
  TileGrid,
  TileMeta,
} from './ui'

export default function BrowseBySeller({
  sellers = SELLERS,
}: {
  /**
   * The tiles to show, already without hidden storefronts. Filtered on the server so the browser
   * never receives the list of hidden storefronts.
   */
  sellers?: readonly SellerTileData[]
}) {
  return (
    <Section
      $background={Colors.Semantic.Neutral.light_grey}
      data-testid="logged-out-browse-by-seller"
    >
      <Inner>
        <SectionTitle>
          <FormattedMessage id="LoggedOutHomepage.browseBySeller.title" />
        </SectionTitle>
        <SectionBody>
          <FormattedMessage
            id="LoggedOutHomepage.browseBySeller.intro"
            values={{
              registerLink: (chunks: React.ReactNode) => (
                <Link href={LINKS.howToRegister}>{chunks}</Link>
              ),
              notOnPhone: (chunks: React.ReactNode) => (
                <NotOnPhone>{chunks}</NotOnPhone>
              ),
            }}
          />
        </SectionBody>
        <TileGrid $phoneColumns={1}>
          {sellers.map((seller) => (
            <li key={seller.slug}>
              <SellerTile href={getStorefrontUrlFromSlug(seller.slug)}>
                <SellerLogo
                  src={seller.logo}
                  alt={seller.name}
                  width={sellerLogoBox.width}
                  height={sellerLogoBox.height}
                />
                <SellerTileText>
                  <TileMeta>
                    <FormattedMessage
                      id="LoggedOutHomepage.browseBySeller.liveListings"
                      values={{ count: seller.listings }}
                    />
                  </TileMeta>
                </SellerTileText>
                <TileChevron aria-hidden>
                  <FontAwesomeIcon icon={faChevronRight} />
                </TileChevron>
              </SellerTile>
            </li>
          ))}
        </TileGrid>
      </Inner>
    </Section>
  )
}
